import PropTypes from "prop-types";

import { EarningsCard as CommonEarningsCard } from "../../../../core/compose/cards";

function EarningsCard({
  id,
  open,
  chosenSchool,
  externalToggle,
  callbackToggle,
}) {
  return (
    <CommonEarningsCard
      id={id}
      open={open}
      chosenSchool={chosenSchool}
      externalToggle={externalToggle}
      callbackToggle={callbackToggle}
    />
  );
}

EarningsCard.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  externalToggle: PropTypes.bool,
  callbackToggle: PropTypes.func,
  chosenSchool: PropTypes.shape(),
};

export default EarningsCard;
